import React, { forwardRef, Fragment, useEffect, useMemo, useState } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { Box, Slide, Paper } from '@material-ui/core';

import Draggable from 'react-draggable';

// Styles
import styles from 'assets/jss/material-dashboard-pro-react/views/notificationsStyle';
import { makeStyles } from '@material-ui/core/styles';
// Icons
import { Close, Refresh } from '@material-ui/icons';
import moment from 'moment/moment';
import { wsGet } from 'services/WService';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const useStyles = makeStyles(styles);

function AnnuledSapModal(props) {
  const classes = useStyles();
  const {
    sheetDistribution = {},
    onProcess,
    setSheetDistribution,
    setProgrammings,
    showNotify,
    reload,
  } = props;
  const [loading, setLoading] = useState(false);
  
  function handleClose(){
    setSheetDistribution(undefined);
  }

  async function refreshOrders(){
    setLoading(true);
    let response = await wsGet('prog/sheet-distribution', sheetDistribution.id);
    setLoading(false);
    if(response.success === false){
      return;
    }

    setProgrammings((sheets) => {
      let index = sheets.findIndex((item) => item.id === sheetDistribution.id);
      if (index !== -1) {
        let newSheets = [...sheets];
        newSheets[index].annuled_orders_count = response.data.annuled_orders_count;
        return newSheets;
      }

      return sheets;
    });
  }

  return (
    <GridContainer>
      <GridItem>
        <Dialog
          open={sheetDistribution.id !== undefined}
          TransitionComponent={Transition}
          PaperComponent={PaperComponent}
          onClose={handleClose}
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle disableTypography style={{ cursor: 'move' }} id="draggable-dialog-title">
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              color="transparent"
              onClick={handleClose}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle} style={{ textAlign: 'center', fontWeight: 'bold' }}>
              Anulación de hoja reparto {sheetDistribution.id}
            </h4>
          </DialogTitle>
          {/* Content */}
          <DialogContent className={classes.modalBody} style={{ minWidth: '500px' }}>
            <Box component={'div'}>
              <GridContainer>
                <GridItem xs={4}>
                  <h6>Día:</h6>
                  <h5>{moment(sheetDistribution.dispatch_date).format('DD-MM-YYYY')}</h5>
                </GridItem>
                <GridItem xs={4}>
                  <h6>Programado:</h6>
                  <h5>{moment(sheetDistribution.scheduled_date).format('DD-MM-YYYY')}</h5>
                </GridItem>
                <GridItem xs={4}>
                  <h6>Vehículo:</h6>
                  <h5>{sheetDistribution.vehicle_plate}</h5>
                </GridItem>

                <GridItem xs={6}>
                  <h6>Jefe de reparto:</h6>
                  <h5>{sheetDistribution.manager_name}</h5>
                </GridItem>

                <GridItem xs={6}>
                  <h6>Encargado de mercadería:</h6>
                  <h5>{sheetDistribution.inventory_manager_name}</h5>
                </GridItem>

                <GridItem xs={4}>
                  <h6>Total de Clientes:</h6>
                  <h5>{sheetDistribution.customers}</h5>
                </GridItem>
                <GridItem xs={4}>
                  <h6>Total de Pedidos:</h6>
                  <h5>{sheetDistribution.orders}</h5>
                </GridItem>

                {sheetDistribution.sapAnnuled !== null && (
                  <GridItem xs={4} style={{ position: 'relative' }}>
                    <h6>Anulados:</h6>
                    <h5>{sheetDistribution.annuled_orders_count}</h5>
                    {sheetDistribution.sapAnnuled === 'P' && (
                      <Button
                        disabled={loading}
                        justIcon
                        round
                        onClick={refreshOrders}
                        color={'info'}
                        style={{ position: 'absolute', top: 0, left: '100px' }}
                      >
                        <Refresh />
                      </Button>
                    )}
                  </GridItem>
                )}
              </GridContainer>

              {sheetDistribution.sapAnnuled !== null && (
                <GridContainer>
                  <GridItem xs={12}>
                    <h3>
                      {sheetDistribution.sapAnnuled === 'Y'
                        ? 'Hoja anulada'
                        : 'Procesando anulación'}
                    </h3>
                  </GridItem>
                </GridContainer>
              )}
            </Box>
          </DialogContent>

          <DialogActions className={classes.modalFooter}>
            {sheetDistribution.sapAnnuled === null && (
              <Button color="success" size="sm" onClick={() => onProcess(sheetDistribution.id)}>
                Anular
              </Button>
            )}

            <Button onClick={handleClose} color="danger" size="sm">
              {sheetDistribution.sapAnnuled !== null ? 'Cerrar' : 'Cancelar'}
            </Button>
          </DialogActions>
        </Dialog>
      </GridItem>
    </GridContainer>
  );
}

export default AnnuledSapModal;
